<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EXXht/tc-custom/FC-9781647505165.jpg?1692133193207?1706795885959" alt="This image is the cover for the book A Luna's Dark Past"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Luna's Dark Past
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>Have you ever been </span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>in</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'> a family where your parents hid things from you? Well</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>,</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'> that is exactly what happened to Artemis. She believed she was just a normal teenager with simple problems. But one terrifying night </span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>her</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'> whole world turned around. She went from being a normal teenage girl to something she never believe</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>d</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'> existed. Will Artemis be able to deal with the new world she has been thrown into? </span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>W</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>ill </span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'>she</span><span style='font-size:10px;font-family:"Arial",sans-serif;color:black;background:white;'> ever be normal again?</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kira Metzger
      </h2>
      
      <p class="authorDescription body article"><p><span style='font-size:13px;font-family:"Times New Roman",serif;'>Kira Metzger is a mother of four. Writing has always been her passion. She works besides studying in a college. She wants to be a role model for her kids.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?51b203d6